<template>
	<div class="container">
		<el-popover placement="right-end" trigger="hover">
			<div class="logoutBox"
				style="width: 2.2rem;background: rgba(31, 32, 39, 1);display: flex;flex-direction: column;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .22rem;">
				QQ客服
				<div class="userName"
					style="margin-top: .12rem;font-weight: 500;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .24rem;">
					<span
						style="font-size: .14rem;color: rgba(255, 255, 255, .6);line-height: .22rem;">客服QQ：</span>{{qqNum}}
				</div>
				<div class="userName"
					style="font-weight: 500;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .24rem;">
					<span
						style="font-size: .14rem;color: rgba(255, 255, 255, .6);line-height: .22rem;">工作时间：</span>9:00-18:30
				</div>
			</div>
			<div class="avatarBox" slot="reference">
				<div class="msgBox">
					<img class="msgIcon" src="../assets/Register/qq.png" />
					QQ客服
				</div>
			</div>
		</el-popover>
		<el-popover placement="right-end" trigger="hover">
			<div class="logoutBox"
				style="width: 2.2rem;background: rgba(31, 32, 39, 1);display: flex;flex-direction: column;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .22rem;">
				电话客服
				<div class="userName"
					style="margin-top: .12rem;font-weight: 500;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .24rem;">
					<span
						style="font-size: .14rem;color: rgba(255, 255, 255, .6);line-height: .22rem;">客服电话：</span>{{phone}}
				</div>
				<div class="userName"
					style="font-weight: 500;font-size: .16rem;color: rgba(255, 255, 255, .8);line-height: .24rem;">
					<span
						style="font-size: .14rem;color: rgba(255, 255, 255, .6);line-height: .22rem;">工作时间：</span>9:00-18:30
				</div>
			</div>
			<div class="avatarBox" slot="reference">
				<div class="severBox">
					<img class="severIcon" src="../assets/Register/sevice.png" />
					电话客服
				</div>
			</div>
		</el-popover>
		<div class="severInfoPop" v-if="severPop">
			<div class="centerContent">
				<img class="sveerIcon" src="../assets/Home/sveerIcon.png" />
				<div class="email">
					客服邮箱：{{email}}
				</div>
				<div class="QQ">
					客服 QQ：{{qqNum}}
				</div>
				<div class="ok" @click="severPop = false">
					好的
				</div>
			</div>
		</div>
		<div class="msgPop" v-if="msgPop">
			<div class="topTitle">
				<div class="unread" v-if="userInfo.wd_count">
					未读消息
					<span>
						（{{userInfo.wd_count}}条）
					</span>
				</div>
				<div v-else></div>
				<div class="read" @click="readAllMsg">
					全部已读
				</div>
			</div>
			<div class="msgTypeList">
				<div class="msgType" v-for="(item,index) in msgTypeData" :key="index" @click="naviToMagCenter(item)">
					<div class="msgTypeIconBox">
						<img class="msgTypeIcon" :src="item.icon" />
						<div class="redPoint" v-if="item.isNewMsg"></div>
					</div>
					<div class="msgTypeTitleBox">
						<div class="msgTypeTitle">{{item.title}}</div>
						<div class="msgTypeContent ellipsis-1">{{item.content}}</div>
					</div>
				</div>
			</div>
			<router-link to="/msg-center?type=all" class="lookAll">
				查看全部信息>>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MsgSever',
		data() {
			return {
				phone: '',
				qqNum: '',
				userId: '',
				userInfo: '',
				msgPop: false,
				severPop: false,
				msgTypeData: [{
					id: 3,
					title: '平台公告',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/platformMsg.png')
				}, {
					id: 2,
					title: '活动通知',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/activityMsg.png')
				}, {
					id: 1,
					title: '站内消息',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/inMsg.png')
				}]
			}
		},
		created() {
			// 监听路由变化事件
			this.$router.afterEach(() => {
				this.hideMsgPop();
			});
		},
		mounted() {
			this.configData()
			if (localStorage.getItem('token')) {
				this.userId = localStorage.getItem('userId')
				this.userDetails()
			}
		},
		methods: {
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						this.msgTypeData[0].isNewMsg = this.userInfo.gg_wd_count != 0 ? true : false
						this.msgTypeData[1].isNewMsg = this.userInfo.hd_wd_count != 0 ? true : false
						this.msgTypeData[2].isNewMsg = this.userInfo.zn_wd_count != 0 ? true : false
						this.msgTypeData[0].content = this.userInfo.gg_wd_last
						this.msgTypeData[1].content = this.userInfo.hd_wd_last
						this.msgTypeData[2].content = this.userInfo.zn_wd_last
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToMagCenter(item) {
				this.$router.push({
					path: `/msg-center?type=${item.id}`
				})
			},
			readAllMsg() {
				this.$api.post('/UserD/clear_message', {}).then(res => {
					if (res.code == 1) {
						this.userDetails()
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'kf_phone') {
								this.phone = item.value
							}
							if (item.title == 'kf_qq') {
								this.qqNum = item.value
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			// 隐藏消息弹窗
			hideMsgPop() {
				this.msgPop = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		position: fixed;
		bottom: 2.8rem;
		right: .2rem;
		z-index: 100;
	}

	.msgBox {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: .56rem;
		height: .66rem;
		background: rgba(152, 232, 62, .2);
		border-radius: .05rem;
		font-weight: 400;
		font-size: .12rem;
		color: rgba(152, 232, 62, 1);
		cursor: pointer;

		.msgIcon {
			margin-top: .04rem;
			margin-bottom: .04rem;
			width: .25rem;
			height: .25rem;
		}
	}

	.severBox {
		margin-top: .12rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: .56rem;
		height: .66rem;
		background: rgba(22, 115, 230, .2);
		border-radius: .05rem;
		font-weight: 400;
		font-size: .12rem;
		color: rgba(22, 115, 230, 1);
		cursor: pointer;

		.severIcon {
			margin-top: .04rem;
			margin-bottom: .04rem;
			width: .25rem;
			height: .25rem;
		}
	}

	.severInfoPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1;

		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;

			.sveerIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.email,
			.QQ {
				margin-top: .24rem;
				margin-left: .24rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.ok {
				margin: .24rem auto;
				width: 1.76rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}

	.msgPop {
		position: absolute;
		bottom: .76rem;
		right: 1rem;
		width: 3.22rem;
		height: 3.26rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		padding: .24rem .24rem 0;
		display: flex;
		flex-direction: column;

		.topTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: .09rem;

			.unread {
				display: flex;
				align-items: center;
				font-weight: 700;
				font-size: .16rem;
				color: #000000;
				line-height: .2rem;

				span {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}

			.read {
				font-size: .14rem;
				color: #E29358;
				line-height: .2rem;
				cursor: pointer;
			}
		}

		.msgTypeList {
			display: flex;
			flex-direction: column;

			.msgType {
				margin-top: .15rem;
				display: flex;
				align-items: center;
				padding-bottom: .15rem;
				border-bottom: .02rem solid rgba(204, 204, 204, .4);
				cursor: pointer;

				.msgTypeIconBox {
					margin-right: .1rem;
					display: flex;
					align-items: center;
					position: relative;

					.msgTypeIcon {
						width: .36rem;
						height: .36rem;
					}

					.redPoint {
						position: absolute;
						top: 0;
						right: 0;
						width: .08rem;
						height: .08rem;
						border-radius: 50%;
						background: #FF0000;
						border: .01rem solid #FFFFFF;
					}
				}

				.msgTypeTitleBox {
					display: flex;
					flex-direction: column;

					.msgTypeTitle {
						font-weight: 500;
						font-size: .14rem;
						color: #333333;
					}

					.msgTypeContent {
						width: 2.2rem;
						font-weight: 400;
						font-size: .14rem;
						color: #666666;
					}
				}
			}
		}

		.lookAll {
			margin: .12rem auto;
			font-size: .14rem;
			color: #E29358;
			line-height: .2rem;
			cursor: pointer;
		}
	}
</style>
<style>
	.el-popover {
		border: none !important;
		min-width: unset !important;
		padding: .2rem .2rem !important;
		background: rgba(31, 32, 39, 1) !important;
	}

	.popper__arrow::after {
		border-left-color: rgba(31, 32, 39, 1) !important;
		border-bottom-color: rgba(31, 32, 39, 1) !important;
	}
</style>